import{createContext as t}from"react";const n={init:()=>{}},e=t(n);var r=e;export{r as default};
